<template>
    <span :title="formatted">{{ (this.timeago) ? since : formatted }}</span>
</template>

<script>

    import moment from "moment";
    import {isObject, isNumber} from "lodash";

    export default {
        name: "FnFormatDate",
        props: {
            value: {
                type: [String, Object, Number],
                required: false,
            },
            format: {
                type: String,
                default() {
                    return "dddd, MMMM Do YYYY, h:mm:ss a";
                }
            },
            source: {
                type: String,
                default() {
                    return "YYYY-MM-DD HH:mm:ss.SSSSSS";
                }
            },
            timeago: {
                type: Boolean
            },
            from: {
                type: [Boolean, String]
            },
            to: {
                type: [Boolean, String]
            },
            humanDiff: {
                type: [Boolean, String]
            },
            ignoreTimeZone: {
                type: Boolean,
                default() {
                    return false;
                }
            },
        },
        computed: {            
            displayDate: function(){
                let date = this.date;
                if (date) {
                    if (this.from || this.timeago) {
                        console.log(date);
                        return date.fromNow();
                    } else if (this.to) {
                        return date.toNow();
                    } else if(this.humanDiff) {
                        return this.calculateAge();
                    } else {
                        return this.formatted;
                    }
                }
                return null;
            },
            formatted: function() {
                return (this.date) ? this.date.format(this.format) : null;
            },
            since: function() {
                return (this.date) ? this.date.fromNow() : null;
            },
            date: function(){
                if (this.value) {
                    var unixMoment = null;
                    if (isNumber(this.value)) {
                        unixMoment = moment.unix(this.value);
                        return this.ignoreTimeZone ? unixMoment : unixMoment.utc().local();
                    } else {
                        unixMoment = moment((isObject && this.value.date) ? this.value.date : this.value, this.source, false);
                        return this.ignoreTimeZone ? unixMoment : unixMoment.utc().local();
                    }
                } else {
                    return null;
                }
            }
        },
        methods: {
            calculateAge() {
                var today = moment();
                var date = moment(this.value);

                var years = today.diff(date, 'year');
                date.add(years, 'years');
                var months = today.diff(date, 'months');
                date.add(months, 'months');

                return `${years} years and ${months} months`;
            }
        }
    };

</script>
